import { Alert, Stack, type SxProps, Typography } from '@mui/material'
import { useAppSelector } from '@/redux/hooks'
import { selectMissingRequirements } from '../selectors'
import type { FieldName, SelectOption } from '../types'

type OptionWarningProps = {
  fieldName: FieldName
}

const textStyle: Record<string, SxProps> = {
  body: {
    display: 'inline',
  },
  bold: {
    breakInside: 'avoid',
    display: 'inline',
    fontWeight: 600,
  },
}

export default function OptionWarning(props: OptionWarningProps) {
  const { fieldName } = props
  const missingRequirements = useAppSelector(selectMissingRequirements())

  const ReqWarnings = missingRequirements
    .filter((req) => req.fieldName === fieldName)
    .map((req) => {
      const missingOptionNames = req.missingOptions
        .map((opt: SelectOption) => opt.description)
        .join(', ')

      return (
        <Alert
          severity="error"
          key={`${req.option.description}-${missingOptionNames}`}
        >
          <Typography sx={textStyle.bold}>{req.option.description}</Typography>
          <Typography sx={textStyle.body}> needs </Typography>
          <Typography sx={textStyle.bold}>{req.missingField.label}</Typography>
          <Typography sx={textStyle.body}> to include </Typography>
          <Typography sx={textStyle.bold}>{missingOptionNames}</Typography>
        </Alert>
      )
    })

  return <Stack spacing={1}>{ReqWarnings}</Stack>
}
